import React from 'react';
import { Link } from 'react-router-dom';
import { Calendar, CheckCircle, Clock, Video, ArrowRight, Shield, Star, ArrowLeft } from 'lucide-react';
import CustomCalendar from '../components/CustomCalendar';

const Konzultace = () => {
  return (

    <div className="min-h-screen bg-gray-50 font-body py-8 flex flex-col justify-center overflow-x-clip">
      <div className="container mx-auto px-4 sm:px-5 max-w-7xl h-full min-w-0">
        <Link to="/" className="inline-flex items-center text-gray-400 hover:text-brand-dark-blue font-bold mb-6 transition-colors group">
          <ArrowLeft className="mr-2 group-hover:-translate-x-1 transition-transform" size={20} />
          Zpět na web
        </Link>
        
        <div>
          <div className="grid lg:grid-cols-12 gap-8 items-stretch h-full">
            
            {/* Left Side - Value Proposition */}
            <div className="lg:col-span-5 flex flex-col space-y-6 h-full min-w-0">
              <div className="bg-white p-8 rounded-3xl shadow-xl shadow-brand-dark-blue/5 border border-white/50 backdrop-blur-sm relative overflow-hidden group hover:shadow-2xl transition-all duration-300 flex-1 flex flex-col justify-center">
                <div className="absolute top-0 right-0 p-8 opacity-5 group-hover:opacity-10 transition-opacity transform group-hover:scale-110 duration-500">
                    <Shield size={110} className="text-brand-dark-blue" />
                </div>

                <h2 className="text-2xl font-heading font-bold text-brand-dark-blue mb-8 flex items-center relative z-10">
                  <div className="w-9 h-9 bg-brand-dark-blue/5 rounded-xl flex items-center justify-center mr-4 text-brand-dark-blue group-hover:bg-brand-dark-blue group-hover:text-white transition-colors duration-300">
                    <Calendar size={18} />
                  </div>
                  Čo získate?
                </h2>
                
                <div className="space-y-6 relative z-10">
                  <div className="flex gap-4 group/item">
                    <div className="flex-shrink-0 mt-1">
                      <div className="w-9 h-9 rounded-full bg-green-50 flex items-center justify-center border border-green-100 group-hover/item:scale-110 transition-transform duration-300">
                        <CheckCircle className="text-green-500" size={18} />
                      </div>
                    </div>
                    <div>
                      <h3 className="font-bold text-gray-900 text-lg">Nezávislý audit</h3>
                      <p className="text-gray-600 text-base leading-relaxed">Profesionálny a objektívny pohľad na vaše aktuálne portfólio a záväzky.</p>
                    </div>
                  </div>

                  <div className="flex gap-4 group/item">
                    <div className="flex-shrink-0 mt-1">
                      <div className="w-9 h-9 rounded-full bg-brand-baby-blue/10 flex items-center justify-center border border-brand-baby-blue/20 group-hover/item:scale-110 transition-transform duration-300">
                        <CheckCircle className="text-brand-dark-blue" size={18} />
                      </div>
                    </div>
                    <div>
                      <h3 className="font-bold text-gray-900 text-lg">Stratégia na mieru</h3>
                      <p className="text-gray-600 text-base leading-relaxed">Konkrétne kroky k efektívnemu budovaniu a ochrane vášho majetku.</p>
                    </div>
                  </div>

                  <div className="flex gap-4 group/item">
                    <div className="flex-shrink-0 mt-1">
                      <div className="w-9 h-9 rounded-full bg-brand-light-orange/30 flex items-center justify-center border border-brand-orange/20 group-hover/item:scale-110 transition-transform duration-300">
                        <CheckCircle className="text-brand-orange" size={18} />
                      </div>
                    </div>
                    <div>
                      <h3 className="font-bold text-gray-900 text-lg">Finančná sloboda</h3>
                      <p className="text-gray-600 text-base leading-relaxed">Plán ako dosiahnuť nezávislosť rýchlejšie a s menším rizikom.</p>
                    </div>
                  </div>
                </div>

                <div className="mt-8 pt-8 border-t border-gray-100 relative z-10">
                  <h4 className="text-xs font-bold text-gray-400 uppercase tracking-widest mb-4">Priebeh konzultácie</h4>
                  <div className="flex flex-wrap gap-4">
                    <div className="flex items-center text-sm font-medium text-gray-700 bg-gray-50 px-3 py-2 rounded-lg border border-gray-100">
                        <Clock size={16} className="text-brand-orange mr-2" />
                        <span>30 minút</span>
                    </div>
                    <div className="flex items-center text-sm font-medium text-gray-700 bg-gray-50 px-3 py-2 rounded-lg border border-gray-100">
                        <Video size={16} className="text-brand-orange mr-2" />
                        <span>Google Meet (Online)</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Trust Badge / Quote */}
              <div className="bg-brand-dark-blue text-white p-8 rounded-3xl shadow-xl relative overflow-hidden group">
                <div className="relative z-10">
                  <div className="text-4xl text-brand-orange absolute -top-2 -left-2 opacity-30 font-serif">"</div>
                  <p className="italic text-brand-gray mb-6 text-lg relative z-10 pl-4">Investícia do vedomostí prináša tie najlepšie úroky.</p>
                  <div className="flex items-center pl-4">
                    <div className="w-10 h-1 bg-brand-orange rounded-full mr-4 group-hover:w-16 transition-all duration-300"></div>
                    <span className="text-sm font-bold tracking-wider uppercase">Benjamin Franklin</span>
                  </div>
                </div>
                {/* Decorative circles */}
                <div className="absolute -bottom-10 -right-10 w-32 h-32 bg-white/5 rounded-full blur-2xl group-hover:bg-white/10 transition-colors duration-500"></div>
              </div>
            </div>

            {/* Right Side - Custom Calendar */}
            <div className="lg:col-span-7 h-full min-w-0">
              <CustomCalendar />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Konzultace;
